import { render, staticRenderFns } from "./RefPricing.vue?vue&type=template&id=4decbd0f"
import script from "./RefPricing.vue?vue&type=script&lang=js"
export * from "./RefPricing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports